import { Component, OnInit } from '@angular/core';
import {UrlService} from '@utils/services/url/url.service';
import {MatDialogConfig} from '@angular/material/dialog';
import {ImageService} from "@utils/services/image/image.service";

@Component({
  selector: 'lib-get-app-dialog',
  templateUrl: './get-app-dialog.component.html',
  styleUrls: ['./get-app-dialog.component.scss']
})
export class GetAppDialogComponent implements OnInit {

  public playStoreLink: string;
  public appStoreLink: string;
  public playStoreIcon = ImageService.StaticImages.GooglePlayStore;
  public appStoreIcon = ImageService.StaticImages.AppleAppStore;

  public static get config(): MatDialogConfig {
    return {
      maxWidth: '600px', width: '80vw', maxHeight: '100vh', autoFocus: false,
    };
  }

  public ngOnInit(): void {
    this.appStoreLink = UrlService.AppStoreLink;
    this.playStoreLink = UrlService.PlayStoreLink;
  }

}
